export default __webpack_public_path__ + "media/pro/cvv_icon-ab56aa90.png";